export default __webpack_public_path__ + "static/media/Hero-Picture 2 - without text.c4d2ef82.jpg";